/* React */
import React from "react";

/* Components */
import DoubleSlider from "src/components/shared/slider/double-slider/DoubleSlider";

/* Stylesheet */
import styles from "./NumericSelect.module.scss";

/* Interfaces */
import {
  BasicProps,
  Keys,
  RangeProps,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

interface NumericSelectProps {
  range: RangeProps;
  boundaries: {
    lowerBound: number;
    upperBound: number;
  };
  disabled: boolean;
  handleUpdate: <K extends keyof BasicProps>(
    key: K,
    data?: { boundaries: BasicProps[K] }
  ) => void;
}

const NumericSelect: React.FC<NumericSelectProps> = ({
  range,
  boundaries,
  handleUpdate,
  disabled,
}) => {
  const { min, max } = range;
  const { lowerBound, upperBound } = boundaries;

  return (
    <div className={styles.numeric_select}>
      <DoubleSlider
        className={"light"}
        min={min}
        max={max}
        value={{
          lower: lowerBound,
          upper: upperBound,
        }}
        pin={true}
        ticks={false}
        inputFields={true}
        disabled={disabled}
        onChange={(value) => {
          const { lower, upper } = value;
          handleUpdate(Keys.BOUNDARIES, {
            boundaries: {
              lowerBound: lower,
              upperBound: upper,
            },
          });
        }}
      />
    </div>
  );
};

export default NumericSelect;
